/**
 * アコーディオン
 * 「.accordion」に対して処理をする
 * 
 */
import { functions } from "../../modules/functions";

export module AccordionModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $accordions = document.querySelectorAll<HTMLElement>('.accordion[data-target]');

      if ($accordions) {
        $accordions.forEach($accordion => {
          const $target = $accordion.getAttribute('data-target');
          if ($target) {
            const $targetElement = document.querySelector<HTMLElement>($target);
            if ($targetElement) {
              $accordion.addEventListener('click', ($event) => {
                $event.preventDefault();
                if ($targetElement.classList.contains('accordion--isActive')) {
                  functions.slideUp($targetElement);
                  $targetElement.classList.remove('accordion--isActive');
                  $accordion.classList.remove('accordion--isActive');
                } else {
                  functions.slideDown($targetElement);
                  $targetElement.classList.add('accordion--isActive');
                  $accordion.classList.add('accordion--isActive');
                }
                return false;
              });
            }
          }
        });
      }
    }
  }
}

